export default "__VITE_ASSET__63901a1c__"